<template>
  <div id="RequestVam">
    <net-pa-list-page-card
      :title="$GetIsAnbohSaz() == 'false' ? 'درخواست وام' : 'درخواست واحد'"
      :description="
        $GetIsAnbohSaz() == 'false'
          ? 'از طریق این فرم می‌توانید درخواست وام خود را ثبت نمایید'
          : 'از طریق این فرم می‌توانید درخواست واحد خود را ثبت نمایید'
      "
      :show-back="true"
    >
      <template v-if="!showGhavaninVam" #toolbar>
        <ul
          class="nav nav-tabs netpa-list-page-header__tabs card-header-tabs request-vam-steps"
          role="tablist"
          dir="rtl"
        >
          <li
            v-for="step in vamSteps"
            :key="step.id"
            class="nav-item"
          >
            <button
              type="button"
              class="nav-link"
              :class="{
                active: divToShow === step.id,
                'request-vam-steps__tab--completed': isStepCompleted(step.id),
                'request-vam-steps__tab--disabled': !canNavigateToStep(step.id),
              }"
              :disabled="!canNavigateToStep(step.id)"
              :title="getStepTabTitle(step.id)"
              @click="goToStep(step.id)"
            >
              <i
                v-if="isStepCompleted(step.id)"
                class="fas fa-check-circle request-vam-steps__check"
                aria-hidden="true"
              ></i>
              <span>{{ step.label }}</span>
            </button>
          </li>
        </ul>
      </template>

      <div v-if="!showGhavaninVam" class="request-vam-content text-right py-3 px-0">
          <div
            v-if="divToShow == 1"
            class="request-vam-step-panel request-vam-step"
          >
            <div class="request-vam-type-list">
              <div
                v-for="(item, key) in Vamha"
                :key="key"
                class="request-vam-type-card"
                :class="{ 'request-vam-type-card--selected': SelectedVam.id == item.id }"
              >
                <div class="request-vam-type-card__row">
                  <div class="request-vam-type-card__aside">
                    <i
                      v-if="SelectedVam.id == item.id"
                      class="fas fa-check-circle request-vam-type-card__check"
                      aria-hidden="true"
                    ></i>
                    <button
                      v-else
                      @click="seLectVam(item)"
                      class="btn NetPa-btn btn-primary request-vam-type-card__select-btn"
                    >
                      انتخاب
                    </button>
                  </div>
                  <div class="request-vam-type-card__info" dir="rtl">
                    <div class="request-vam-type-card__name">
                      <span class="request-vam-type-card__label">نام تسهیلات:</span>
                      <span class="request-vam-type-card__title">{{ item.desNoe }}</span>
                    </div>
                    <p
                      v-if="item.tozihatForRequestVam"
                      class="request-vam-type-card__desc"
                    >
                      {{ item.tozihatForRequestVam }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="request-vam-step-nav request-vam-step-nav--next-only">
              <button
                type="button"
                :disabled="Object.entries(SelectedVam).length === 0"
                @click="nextPage(2)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
              >
                مرحله بعد
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div v-if="divToShow == 2" class="request-vam-step-panel request-vam-step">
            <div class="row request-vam-form-grid mx-0">
              <div class="col-12 col-md-6 py-2">
                <label for="MabVam" class="text-secondary"> مبلغ وام</label>
                <input type="text" :disabled="SelectedVam.fixMablagh" id="MabVam"
                  class="form-control text-left 3ragham" v-model="vamDetail.MablaghVam" @keyup="
            $PutCommatoInput()
          calculateMablaghghest()
          CheckupSaghfVam($event)
            " @keypress="$ValidNumber($event, 15, false)" dir="ltr" />
              </div>
              <div class="col-12 col-md-6 py-2 request-vam-date-field">
                <label for="NeedData" class="text-secondary d-block">تاریخ نیاز</label>
                <date-picker :disabled="$session.get('CustCode') == 868" v-model="vamDetail.NeedData"
                  color="#f38905"></date-picker>
                <input type="text" id="NeedData" v-model="vamDetail.NeedData" class="d-none InputText" dir="ltr" />
              </div>
              <div class="col-12 col-md-6 py-2">
                <label for="ghestNum" class="text-secondary"> تعداد قسط</label>
                <input v-if="$session.get('CustCode') != 868" type="text" @keyup="calculateMablaghghest"
                  :disabled="SelectedVam.fixTedad" id="ghestNum" v-model="vamDetail.TedadGhest"
                  class="form-control text-left" maxlength="2" @keypress="$ValidNumber($event, 12, false)"
                  dir="ltr" />

                <select v-else class="form-control text-center" v-model="vamDetail.TedadGhest"
                  @change="calculateMablaghghest($event)">
                  <option :value="24">24</option>
                  <option :value="36">36</option>
                  <option :value="48">48</option>
                </select>
              </div>
              <div class="col-12 col-md-6 py-2" v-if="this.$session.get('CustCode') != 9">
                <label for="ghestmab" class="text-secondary"> مبلغ قسط</label>
                <input disabled="disabled" type="text" id="ghestmab" v-model="vamDetail.Mablaghghest"
                  class="form-control text-left 3ragham" />
              </div>
              <div class="col-12 col-md-6 py-2"
                v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 8002">
                <label class="text-secondary"> نحوه پرداخت وام</label>
                <select v-model="nahvepardakht" class="form-control Pointer">
                  <option value="4014">واریز به حساب بانکی</option>
                  <option selected value="4015">واریز به حساب پس انداز</option>
                </select>
              </div>
              <div class="col-12 col-md-6 py-2"
                v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 8002">
                <span v-if="nahvepardakht == 4015">
                  <label class="text-secondary">انتخاب حساب پس انداز </label>
                  <select class="form-control Pointer" v-model="NahveVarizDetail">
                    <option v-for="item in ListTaahodat" :key="item.id" :value="item.id">{{ item.desNoe }}</option>
                  </select>
                </span>
                <span v-if="nahvepardakht == 4014">
                  <label class="text-secondary">انتخاب حساب بانکی </label>
                  <select class="form-control Pointer" v-model="NahveVarizDetail">
                    <option v-for="item in ListAzaHesab" :key="item.id" :value="item.id">{{ item.bankName }} -- {{
            item.hesabNo }}</option>
                  </select>
                </span>
              </div>
            </div>
            <div class="request-vam-step-nav">
              <button
                type="button"
                @click="prevPage(1)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
              >
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
                مرحله قبل
              </button>
              <button
                type="button"
                :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0"
                @click="nextPage(3)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
              >
                مرحله بعد
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div v-if="divToShow == 3" class="request-vam-step-panel request-vam-step">
            <div
              v-if="guarantorIndices.length === 0"
              class="alert alert-secondary text-right mb-0"
            >
              برای این نوع تسهیلات ضامنی نیاز نیست.
            </div>
            <div v-else class="request-vam-zamen-grid">
              <div
                v-for="index in guarantorIndices"
                :key="index"
                class="request-vam-zamen-slot"
                :class="{ 'request-vam-zamen-slot--solo': isGuarantorSoloRow(index) }"
              >
                <div class="request-vam-zamen-input-group">
                  <input
                    type="text"
                    inputmode="numeric"
                    maxlength="10"
                    class="form-control request-vam-zamen-code"
                    v-model="ListCodeMeli[index]"
                    :placeholder="guarantorPlaceholder(index)"
                    dir="ltr"
                  />
                  <button
                    type="button"
                    class="request-vam-zamen-check-btn"
                    @click="GetZament(index)"
                  >
                    بررسی
                  </button>
                </div>
                <div
                  v-if="ListZamen[index].NameFamily != ''"
                  class="request-vam-zamen-result"
                >
                  <span class="text-secondary">نام ضامن:</span>
                  <span class="text-dark font-weight-bold request-vam-zamen-result__name">{{
                    ListZamen[index].NameFamily
                  }}</span>
                </div>
              </div>
            </div>
            <button
              class="d-none"
              id="ZamenModal"
              data-toggle="modal"
              data-target="#Modal-Orange"
            >
              modal
            </button>
            <div class="request-vam-step-nav">
              <button
                type="button"
                @click="prevPage(2)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
              >
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
                مرحله قبل
              </button>
              <button
                type="button"
                :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0"
                @click="nextPage(4)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
              >
                مرحله بعد
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div v-if="divToShow == 4" class="request-vam-step-panel request-vam-step">
            <div class="request-vam-upload-section">
              <div
                v-if="$session.get('CustCode') != 868 && $cookies.isKey('DownloadForm')"
                class="request-vam-upload-download alert alert-warning text-right mb-3"
              >
                برای دانلود فرم درخواست وام
                <a :href="$cookies.get('DownloadForm')" download="فرم درخواست وام">
                  <span class="badge badge-success">اینجا</span>
                </a>
                کلیک کنید.
              </div>

              <div v-if="$session.get('CustCode') != 868" class="request-vam-upload-card">
                <input
                  type="file"
                  id="attachmentUploader"
                  @change="changeattach($event)"
                  class="d-none"
                  accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                />
                <div class="request-vam-upload-card__icon">
                  <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                </div>
                <p class="request-vam-upload-card__title">بارگذاری مدارک درخواست وام</p>
                <p class="request-vam-upload-card__hint">
                  فرمت‌های مجاز: gif, jpg, png, zip, rar, pdf — حداکثر ۳ مگابایت
                </p>
                <div v-if="attachment" class="request-vam-upload-card__meta">
                  <div><span class="text-secondary">نام فایل:</span> {{ attachment.name }}</div>
                  <div>
                    <span class="text-secondary">حجم:</span>
                    {{ Math.round(attachment.size / 1000) }} KB
                  </div>
                </div>
                <button
                  type="button"
                  class="request-vam-upload-card__btn"
                  @click="clickUploader"
                >
                  {{ attachment ? 'تغییر فایل' : 'انتخاب فایل' }}
                </button>
              </div>

              <div v-else class="request-vam-upload-grid">
                <div class="request-vam-upload-card request-vam-upload-card--item">
                  <input
                    type="file"
                    class="d-none"
                    id="FileHokm"
                    accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                    @change="UploadFile($event, 1, 'FileHokm')"
                  />
                  <div class="request-vam-upload-card__icon">
                    <i class="fa fa-file-import" aria-hidden="true"></i>
                  </div>
                  <p class="request-vam-upload-card__title">حکم کارگزینی وام‌گیرنده و ضامن</p>
                  <p v-if="FileHokm868" class="request-vam-upload-card__file-name">
                    {{ FileHokm868.name }}
                  </p>
                  <button type="button" class="request-vam-upload-card__btn" @click="OpenUploader(1)">
                    {{ FileHokm868 ? 'تغییر فایل' : 'بارگذاری' }}
                  </button>
                </div>
                <div class="request-vam-upload-card request-vam-upload-card--item">
                  <input
                    type="file"
                    class="d-none"
                    id="FileZemanat"
                    accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                    @change="UploadFile($event, 2, 'FileZemanat')"
                  />
                  <div class="request-vam-upload-card__icon">
                    <i class="fa fa-file-import" aria-hidden="true"></i>
                  </div>
                  <p class="request-vam-upload-card__title">فرم ضمانت</p>
                  <p v-if="FileZamenanat868" class="request-vam-upload-card__file-name">
                    {{ FileZamenanat868.name }}
                  </p>
                  <button type="button" class="request-vam-upload-card__btn" @click="OpenUploader(2)">
                    {{ FileZamenanat868 ? 'تغییر فایل' : 'بارگذاری' }}
                  </button>
                </div>
                <div class="request-vam-upload-card request-vam-upload-card--item">
                  <input
                    type="file"
                    class="d-none"
                    id="FileGhrardad"
                    accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                    @change="UploadFile($event, 3, 'FileGhrardad')"
                  />
                  <div class="request-vam-upload-card__icon">
                    <i class="fa fa-file-import" aria-hidden="true"></i>
                  </div>
                  <p class="request-vam-upload-card__title">قرارداد وام</p>
                  <p v-if="FileGhardad868" class="request-vam-upload-card__file-name">
                    {{ FileGhardad868.name }}
                  </p>
                  <button type="button" class="request-vam-upload-card__btn" @click="OpenUploader(3)">
                    {{ FileGhardad868 ? 'تغییر فایل' : 'بارگذاری' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="request-vam-step-nav">
              <button
                type="button"
                @click="prevPage(3)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
              >
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
                مرحله قبل
              </button>
              <button
                type="button"
                @click="nextPage(5)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
              >
                مرحله بعد
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div v-if="divToShow == 5" class="request-vam-step-panel request-vam-step">
            <div class="request-vam-review-header">
              <h4 class="request-vam-review-header__title">تایید نهایی درخواست</h4>
            </div>

            <section class="request-vam-review-section request-vam-review-section--loan">
              <h6 class="request-vam-review-section__title">مشخصات وام</h6>
              <div class="request-vam-review-fields">
                <div class="request-vam-review-field">
                  <span class="request-vam-review-field__label">نام تسهیلات درخواستی</span>
                  <span class="request-vam-review-field__value">{{
                    SelectedVam.desNoe
                  }}</span>
                </div>
                <div class="request-vam-review-field">
                  <span class="request-vam-review-field__label">مبلغ درخواستی</span>
                  <span
                    class="request-vam-review-field__value request-vam-review-field__value--ltr"
                  >
                    {{ $Comma3ragham(vamDetail.MablaghVam) }}
                    {{ $GetVahedPool() }}
                  </span>
                </div>
                <div
                  v-if="this.$session.get('CustCode') != 9"
                  class="request-vam-review-field"
                >
                  <span class="request-vam-review-field__label">مبلغ هر قسط</span>
                  <span
                    class="request-vam-review-field__value request-vam-review-field__value--ltr"
                  >
                    {{ $Comma3ragham(vamDetail.Mablaghghest) }}
                    {{ $GetVahedPool() }}
                  </span>
                </div>
                <div class="request-vam-review-field">
                  <span class="request-vam-review-field__label">تعداد قسط</span>
                  <span
                    class="request-vam-review-field__value request-vam-review-field__value--ltr"
                    >{{ vamDetail.TedadGhest }}</span
                  >
                </div>
                <div class="request-vam-review-field">
                  <span class="request-vam-review-field__label">تاریخ نیاز وام</span>
                  <span
                    class="request-vam-review-field__value request-vam-review-field__value--ltr"
                    >{{ vamDetail.NeedData }}</span
                  >
                </div>
              </div>
            </section>

            <section class="request-vam-review-section request-vam-review-section--guarantors">
              <h6 class="request-vam-review-section__title">مشخصات ضامنین</h6>
              <div
                v-if="reviewGuarantors.length === 0"
                class="request-vam-review-guarantor-empty"
              >
                ضامنی ثبت نشده است.
              </div>
              <div v-else class="request-vam-review-guarantor-list">
                <article
                  v-for="(item, key) in reviewGuarantors"
                  :key="item.Id || item.CodeMeli || key"
                  class="request-vam-review-guarantor-card"
                >
                  <header class="request-vam-review-guarantor-card__header">
                    <span class="request-vam-review-guarantor-card__badge">{{
                      key + 1
                    }}</span>
                    <span class="request-vam-review-guarantor-card__title">{{
                      item.NameFamily
                    }}</span>
                  </header>
                  <div class="request-vam-review-guarantor-card__grid">
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label">کدملی</span>
                      <span
                        class="request-vam-review-field__value request-vam-review-field__value--ltr"
                        >{{ item.CodeMeli }}</span
                      >
                    </div>
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label">نام پدر</span>
                      <span class="request-vam-review-field__value">{{
                        item.Pedar
                      }}</span>
                    </div>
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label">شماره تماس</span>
                      <span
                        class="request-vam-review-field__value request-vam-review-field__value--ltr"
                        >{{ item.Tel }}</span
                      >
                    </div>
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label">شماره همراه</span>
                      <span
                        class="request-vam-review-field__value request-vam-review-field__value--ltr"
                        >{{ item.Mobile }}</span
                      >
                    </div>
                    <div
                      class="request-vam-review-field request-vam-review-field--full"
                    >
                      <span class="request-vam-review-field__label">آدرس</span>
                      <span class="request-vam-review-field__value">{{
                        item.Adres
                      }}</span>
                    </div>
                  </div>
                </article>
              </div>
            </section>

            <section class="request-vam-review-section request-vam-review-section--files">
              <h6 class="request-vam-review-section__title">مشخصات فایل‌ها</h6>
              <div v-if="attachment == null" class="request-vam-review-files">
                <h6 v-if="$session.get('CustCode') == 868 && FileHokm868 == null" class="text-danger">فایل حکم کارگزینی
                  بارگذاری نشده</h6>
                <!-- <h6 v-else class="">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">نام فایل: </span>
                      <span>{{ FileHokm868.name }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">حجم فایل: </span>
                      <span>{{ FileHokm868.size / 1000000 }} Mb</span>
                    </div>
                  </div>
                </h6> -->

                <h6 v-if="$session.get('CustCode') == 868 && FileZamenanat868 == null" class="text-danger">فایل ضمانت
                  بارگذاری نشده</h6>
                <!-- <h6 v-else class="">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">نام فایل: </span>
                      <span>{{ FileZamenanat868.name }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">حجم فایل: </span>
                      <span>{{ FileZamenanat868.size / 1000000 }} Mb</span>
                    </div>
                  </div>
                </h6> -->

                <h6 v-if="$session.get('CustCode') == 868 && FileGhardad868 == null" class="text-danger">فایل قرارداد
                  بارگزاری نشده</h6>
                <!-- <h6 v-else class="">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">نام فایل: </span>
                      <span>{{ FileGhardad868.name }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">حجم فایل: </span>
                      <span>{{ FileGhardad868.size / 1000000 }} Mb</span>
                    </div>
                  </div>
                </h6> -->

                <h6 v-if="$session.get('CustCode') != 868" class="text-danger mb-0">فایلی بارگزاری نشده</h6>
              </div>
              <div v-else class="request-vam-review-files row mx-0">
                <div class="col-md-6 col-12">
                  <span class="text-secondary">نام فایل: </span>
                  <span>{{ attachment.name }}</span>
                </div>
                <div class="col-md-6 col-12">
                  <span class="text-secondary">حجم فایل: </span>
                  <span>{{ attachment.size / 1000000 }} Mb</span>
                </div>
              </div>
            </section>
            <div class="request-vam-step-nav">
              <button
                type="button"
                @click="prevPage(4)"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
              >
                <i class="fa fa-arrow-right" aria-hidden="true"></i>
                مرحله قبل
              </button>
              <button
                type="button"
                @click="FinalSubmit"
                class="request-vam-step-nav__btn request-vam-step-nav__btn--submit"
              >
                <i class="fa fa-check" aria-hidden="true"></i>
                ثبت نهایی درخواست
              </button>
            </div>
          </div>
      </div>
      <div v-else class="request-vam-rules text-right p-3">
        <div class="row" style="font-size: large !important;">
          <h4>
            قوانین و مقررات دریافت وام
          </h4>

          <p>
            اظهار مینمایم که ذیحسابی سازمان خبرگزاری جمهوری اسلامی وکالت بلاعزل دارد معادل مبلغ وام پرداختی به انضمام
            کارمزد و هزینه های مزبور را بر اساس رقم و تعداد اقساطی که از سوی شرکت تعاونی به ذیحسابی اعلام میشود از حقوق
            و سایر مزایا و مطالبات اینجانب کسر و به حساب شرکت تعاونی واریز نماید. در ضمن متعهد می شوم چنانچه به هر دلیلی
            همکاری خود را با سازمان خبرگزاری جمهوری اسلامی اعم از دائم یا موقت (شامل مرخصی بدون حقوق ،آموزش، ماموریت و
            سایر موارد )قطع نمایم ضمن اعلام به شرکت ، کل مبلغ وام را یکجا تسویه نمایم و همچنین شرکت مختار است در صورت
            عدم دسترسی از ضامنین کسر نماید
          </p>

          <div class="d-flex">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminate"
                v-model="isAcceptSharaytVam" />
              <label class="form-check-label mx-3" for="flexCheckIndeterminate">
                قوانین و مقررات را مطلاعه نموده و قبول دارم
              </label>
            </div>

          </div>
          <div class="d-flex flex-row justify-content-end w-100 m-3">
            <button :disabled="!isAcceptSharaytVam" class="btn btn-success NetPa-btn" style="width: 25%;" @click="()=> showGhavaninVam = false">مرحله بعد
            </button>
          </div>


        </div>
      </div>
    </net-pa-list-page-card>

    <modal-custom>
      <template v-slot:ContentModalOrange>
        <div class="container-fluid">
          <div v-if="!AtachVam" class="row">
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="نام نام خانوادگی" class="form-control"
                v-model="ZamenToInsert.NameFamily" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="نام پدر" class="form-control" v-model="ZamenToInsert.Pedar" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="شغل" class="form-control" v-model="ZamenToInsert.Job" />
            </div>
            <!-- <div class="col-12 col-md-6 p-2">
                            <input type="text" placeholder="شغل " class="form-control" v-model="ZamenToInsert.NameFamily">
                        </div> -->
            <div class="col-12 col-md-6 p-2">
              <input type="number" placeholder="تلفن ثابت" class="form-control text-left" v-model="ZamenToInsert.Tel" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="number" placeholder="تلفن همراه" class="form-control text-left"
                v-model="ZamenToInsert.Mobile" />
            </div>
            <div class="col-12 p-2 col-md-12">
              <textarea type="text" class="form-control" v-model="ZamenToInsert.Adres"> </textarea>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <button class="btn btn-primary NetPa-btn w-100" data-dismiss="modal">ثبت ضامن</button>
            </div>
            <div class="col-md-4"></div>
          </div>
          <div v-else class="row">
            <div class="col-12 alert alert-warning">جدول امتیازات وام شما به صورت زیر می باشد</div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First</th>
                  <th scope="col">Last</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                </tr>
                <tr>
                  <th scope="row">3</th>
                  <td>Larry</td>
                  <td>the Bird</td>
                  <td>@twitter</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaListPageCard from '../Tools/NetPa/NetPaListPageCard.vue'
import ModalCustom from '../Tools/ModalCustom.vue'

export default {
  components: { NetPaListPageCard, ModalCustom },

  data() {
    return {
      isAcceptSharaytVam: false,
      showGhavaninVam: false,
      TblNoeId: null,
      NahveVarizDetail: null,
      AtachVam: false,
      nahvepardakht: 4015,
      DataAxiosTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosAzaHesab: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'AzaHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListTaahodat: [],
      ListAzaHesab: [],
      DataAxiosGetNoeVam: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVam',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionVamCondition: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'VamCondition',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionNoePolicy: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'NoePolicy',
        Token: this.$session.get('TokenNetPa'),
      },
      Vamha: [],
      divToShow: 1,
      maxReachedStep: 1,
      completedSteps: [],
      SelectedVam: {},
      vamDetail: {
        Mablaghghest: 0,
        TedadGhest: 24,
        MablaghVam: 0,
        NeedData: '',
      },
      ListZamen: [
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
      ],
      ZamenToInsert: {},
      ListCodeMeli: ['', '', ''],
      attachment: null,
      FileHokm868: null,
      FileZamenanat868: null,
      FileGhardad868: null,
      needVamId: 0,
      requiredZamenCount: 3,
    }
  },
  computed: {
    vamSteps() {
      return [
        { id: 1, label: 'انتخاب نوع وام' },
        { id: 2, label: 'اطلاعات تکمیلی' },
        { id: 3, label: 'مشخصات ضامنین' },
        { id: 4, label: 'آپلود مدارک' },
        { id: 5, label: 'تایید نهایی' },
      ]
    },
    guarantorIndices() {
      const count = Math.max(
        0,
        Math.min(3, Number(this.requiredZamenCount) || 3),
      )
      return Array.from({ length: count }, (_, index) => index)
    },
    reviewGuarantors() {
      return (this.ListZamen || []).filter(
        (item) => item && item.Id != null,
      )
    },
  },
  mounted() {
    this.vamDetail.NeedData = this.$GetJalaliDate()
    this.GetNoeVam()

    if (this.$session.get('CustCode') == 643) {
      this.showGhavaninVam = true
    }

  },
  methods: {

    GetNoeVam() {
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      this.DataAxiosGetNoeVam.ArryfildValue = formdata
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Vamha = data
      })
    },
    selectCurent(data, number) {
      this.activateStep(number)
    },
    isGuarantorSoloRow(index) {
      const total = this.guarantorIndices.length
      return total === 1 || (total % 2 === 1 && index === total - 1)
    },
    guarantorPlaceholder(index) {
      const labels = ['اول', 'دوم', 'سوم']
      return `کدملی ضامن ${labels[index] || index + 1}`
    },
    resolveRequiredZamenCount(result, data) {
      const policyCount =
        result && result.tedad != null && result.tedad !== ''
          ? Number(result.tedad)
          : null
      const vamCount =
        data && data.tedadZamen != null && data.tedadZamen !== ''
          ? Number(data.tedadZamen)
          : null
      const resolved = policyCount ?? vamCount ?? 3
      if (Number.isNaN(resolved)) return 3
      return Math.max(0, Math.min(3, resolved))
    },
    getVamAmount(value) {
      if (value == null || value === '') return 0
      return Number(String(value).replaceAll(/,/g, '').replace(/\./g, '')) || 0
    },
    isStepCompleted(step) {
      return this.completedSteps.includes(step)
    },
    isStepUnlocked(step) {
      if (step === 1) return true
      if (step === 2) return Object.entries(this.SelectedVam).length !== 0
      if (step === 3) {
        return (
          this.getVamAmount(this.vamDetail.Mablaghghest) !== 0 &&
          this.getVamAmount(this.vamDetail.MablaghVam) !== 0
        )
      }
      return true
    },
    canNavigateToStep(step) {
      if (step > this.maxReachedStep) return false
      return this.isStepUnlocked(step)
    },
    getStepTabTitle(step) {
      if (this.canNavigateToStep(step)) return ''
      if (step === 2 && Object.entries(this.SelectedVam).length === 0) {
        return 'ابتدا نوع وام را مشخص کنید'
      }
      if (
        step === 3 &&
        (this.getVamAmount(this.vamDetail.Mablaghghest) === 0 ||
          this.getVamAmount(this.vamDetail.MablaghVam) === 0)
      ) {
        return 'لطفا اطلاعات وام را تکمیل کنید'
      }
      if (step > this.maxReachedStep) {
        return 'ابتدا مراحل قبلی را تکمیل کنید'
      }
      return ''
    },
    goToStep(step) {
      if (!this.canNavigateToStep(step)) return
      window.scrollTo({ top: 0 })
      this.divToShow = step
    },
    prevPage(step) {
      if (step < 1 || step > 5) return
      this.goToStep(step)
    },
    activateStep(number) {
      for (let i = 1; i < number; i++) {
        if (!this.completedSteps.includes(i)) {
          this.completedSteps.push(i)
        }
      }
      this.maxReachedStep = Math.max(this.maxReachedStep, number)
      this.divToShow = number
      window.scrollTo({ top: 0 })
    },
    seLectVam(data) {     
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('wwwtblNoeId', data.id)
      this.TblNoeId = data.id
      this.DataActionVamCondition.ArryfildValue = formdata
      this.DataActionNoePolicy.ArryfildValue = formdata
      this.$PostFormData(this.DataActionVamCondition).then((res) => {
        this.$store.state.loading = true
        switch (res.id) {
          case 0:
            this.$PostFormData(this.DataActionNoePolicy).then((result) => {
              if (result.result == 'SUCCESS') {
                this.SelectedVam = data
                this.requiredZamenCount = this.resolveRequiredZamenCount(result, data)
                this.vamDetail.MablaghVam = this.$Comma3ragham(data.mablaghVam)
                if (this.$session.get('CustCode') == 868 && data.tedadGhestVam == 0) {
                  this.vamDetail.TedadGhest = 24
                } else {
                  this.vamDetail.TedadGhest = data.tedadGhestVam
                }
                this.vamDetail.Mablaghghest = data.mablaghVam > 0 ? Math.floor(Number(data.mablaghVam) / Number(data.tedadGhestVam)) : 0
              } else {
                this.$mySweetDefault('هشدار', result.result, 'warning', 2000)
              }
            })
            break
          case 1:
            this.$mySweetDefault('هشدار', 'سابقه عضویت شما جهت درخواست وام کافی نمیباشد.', 'warning', 2000)
            break
          case 2:
            this.$mySweetDefault('هشدار', 'تعداد تسهیلات دریافتی شما بیش از حد مجاز میباشد.', 'warning', 2000)
            break
          case 3:
            this.$mySweetDefault('هشدار', 'سقف بودجه ماهیانه به اتمام رسیده است.', 'warning', 2000)
            break

          case 5:
            this.$mySweetDefault('هشدار', 'موجودی حساب شما جهت درخواست تسهیلات کمتر از سقف تایید شده میباشد.', 'warning', 2000)
            break
          case 6:
            this.$mySweetDefault('هشدار', 'دریافت این نوع تسهیلات برای حوزه و یا نوع عضویت شما فعال نمیباشد.', 'warning', 2000)
            break
          case 7:
            this.$mySweetDefault('هشدار', 'به علت بدهی قبلی از این نوع تسهیلات شما مجاز به ثبت درخواست نمیباشید.', 'warning', 2000)
            break
          case 8:
            this.$mySweetDefault('هشدار', 'این تسهیلات پیش از این توسط شما درخواست داده شده است.', 'warning', 2000)
            break
          default:
            this.$mySweetDefault('خطا', 'پاسخی از سرور دریافت نشد.', 'error', 2000)
        }
        this.$store.state.loading = false
      })
    },
    nextPage(number) {
      // console.log("@@", number);
      if (number == 2) {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxiosTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosTaahodat).then((data) => {
          this.ListTaahodat = data
        })

        this.DataAxiosAzaHesab.ArryfildValue = { Id: this.$session.get('UserInfoNetPa').wwwtblAzaId }
        this.$GetData_Header(this.DataAxiosAzaHesab).then((data) => {
          this.ListAzaHesab = data
        })
      }

      if (number == 3 && (this.vamDetail.Mablaghghest == 0 || this.vamDetail.MablaghVam == 0)) {
        this.$mySweetDefault('هشدار', 'مبلغ وام و یا قسط آن نمیتواند صفر باشد.', 'warning', 2000)
      } else if (number == 3 && this.vamDetail.TedadGhest == 0) {
        this.$mySweetDefault('هشدار', 'تعداد قسط نمیتواند خالی باشد', 'warning', 2000)
      } else if (number == 3) {
        if (this.$session.get('CustCode') == 9) {
          this.cusCode9_VamRules()
        } else {
          this.activateStep(number)
        }
      } else {
        this.activateStep(number)
      }
    },
    calculateMablaghghest(e) {
      // this.vamDetail.TedadGhest = this.vamDetail.TedadGhest == 0 ? 1 : this.vamDetail.TedadGhest
      if (this.$session.get('CustCode') == 868) {
        var formdata = new FormData()
        formdata.append('wwwtblNoeId', this.SelectedVam.id)
        formdata.append('MabDarkhastVam', Number(this.vamDetail.MablaghVam.replace(/,/g, '')))
        formdata.append('TedadGhest', this.vamDetail.TedadGhest)
        formdata.append('TarixDarkhast', this.vamDetail.NeedData)
        var DataAxios = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'InsNewVam/CalcKarmozd',
          Token: this.$session.get('TokenNetPa'),
        }
        this.$PostFormData(DataAxios).then((res) => {
          this.vamDetail.Mablaghghest = (res.data[0].karmozdBimeSood + Number(this.vamDetail.MablaghVam.replace(/,/g, ''))) / this.vamDetail.TedadGhest
          this.vamDetail.Mablaghghest = Math.round(this.vamDetail.Mablaghghest)
          this.vamDetail.Mablaghghest = this.vamDetail.Mablaghghest + ''
          this.vamDetail.Mablaghghest = Number(this.vamDetail.Mablaghghest.replace(/\d{4}$/, '0000'))
        })
      } else {
        if (this.vamDetail.TedadGhest == 0) {
          this.vamDetail.Mablaghghest = 0
        } else {
          this.vamDetail.Mablaghghest = Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) > 0 ? Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) / this.vamDetail.TedadGhest : 0
        }
      }
    },

    cusCode9_VamRules() {
      let request = {
        Amount: this.vamDetail.MablaghVam.replaceAll(',', ''),
        NoeId: this.TblNoeId,
        TedadGhest: this.vamDetail.TedadGhest,
      }
      this.$PostData_new('VamCondition/CusCode9_VamRules', 'post', request).then((res) => {
        if (res.isSuccess == true) {
          this.activateStep(3)
        } else {
          if (res.data != null) {
            let maxVam = this.$Comma3ragham(res.data)
            let messge = res.message + maxVam + ' است'
            this.$mySweetDefault('هشدار', messge, 'warning')
          } else {
            this.$mySweetDefault('هشدار', res.message, 'warning')
          }
          return
        }
      })
    },
    GetZament(number) {
      if (this.$session.get('UserInfoNetPa').codeMeli.trim() == this.ListCodeMeli[number]) {
        this.$mySweetDefault('خطا', 'شما کد ملی خود را وارد کرده اید', 'error', 2000)
        return
      }

      if (number == 0) {
        if (this.ListCodeMeli[1] == this.ListCodeMeli[0]) {
          this.ListCodeMeli[0] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[2] == this.ListCodeMeli[0]) {
          this.ListCodeMeli[0] = ''
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          return
        }
      }
      if (number == 1) {
        if (this.ListCodeMeli[0] == this.ListCodeMeli[1]) {
          this.ListCodeMeli[1] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[2] == this.ListCodeMeli[1]) {
          this.ListCodeMeli[1] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)

          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
      }
      if (number == 2) {
        if (this.ListCodeMeli[0] == this.ListCodeMeli[2]) {
          this.ListCodeMeli[2] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[1] == this.ListCodeMeli[2]) {
          this.ListCodeMeli[2] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
      }

      if (this.ListCodeMeli[number].length < 10) {
        this.$mySweetDefault('خطا', ' طول کد ملی نمیتواند کمتر از 10 رقم باشد', 'error', 2000)
      } else {
        var DataAxiosGetZament = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'GetZamenByMelli2',
          Token: this.$session.get('TokenNetPa'),
        }
        var formdata = new FormData()
        formdata.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        formdata.append('CodeMeli', this.ListCodeMeli[number])
        DataAxiosGetZament.ArryfildValue = formdata
        this.$PostFormData(DataAxiosGetZament).then((data) => {
          if (data != null) {
            if (data.success && data.success == 'Fail') {
              this.$mySweetDefault('خطا', data.message, 'error', 3500)
            } else if (data.mandeZemanat != null) {
              if (data.mandeZemanat >= Number(this.vamDetail.MablaghVam.replace(/\,/g, ''))) {
                //مبلغ وام کمتر از سقف ضمانت می باشد
                this.ListZamen[number].Tel = data.tel
                this.ListZamen[number].Pedar = data.pedar
                this.ListZamen[number].NameFamily = data.nameFamily
                this.ListZamen[number].Mobile = data.mobile
                this.ListZamen[number].Adres = data.adres
                this.ListZamen[number].Id = data.id
                this.ListZamen[number].CodeMeli = this.ListCodeMeli[number]
              } else {
                this.$mySweetDefault('خطا', 'ضامن وارد شده به سقف ضمانت خود رسیده ، لطفا ضامن دیگری انتخاب نمایید', 'error', 3500)
              }
            } else {
              this.ListZamen[number].Tel = data.tel
              this.ListZamen[number].Pedar = data.pedar
              this.ListZamen[number].NameFamily = data.nameFamily
              this.ListZamen[number].Mobile = data.mobile
              this.ListZamen[number].Adres = data.adres
              this.ListZamen[number].Id = data.id
              this.ListZamen[number].CodeMeli = this.ListCodeMeli[number]
            }
          } else {
            this.ZamenToInsert = this.ListZamen[number]
            this.$mySweetDefault('هشدار', 'فرد مورد نظر در بین مشتریان ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' یافت نشد. مشخصات ضامن را به صورت دستی وارد کنید.', 'warning', 3500)
            document.getElementById('ZamenModal').click()
          }
        })
      }
    },
    clickUploader() {
      document.getElementById('attachmentUploader').click()
    },
    changeattach(e) {
     const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      this.attachment = document.getElementById('attachmentUploader').files[0]
      if (this.attachment.size / 1000000 > 5) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 5 مگابایت باشد', 'error', 2000)
        document.getElementById('attachmentUploader').value = null
        this.attachment = null
      }
    },
    FinalSubmit() {
      var formdata = new FormData()

      if (this.ListCodeMeli[0] == null) {
        this.$mySweetDefault('عملیات ناموفق', 'وارد کردن ضامن اول اجباری میباشد', 'error', 2500)
        return
      }

      this.vamDetail.MablaghVam = this.vamDetail.MablaghVam.replaceAll(',', '')

      formdata.append('NahveVarizDetail', this.NahveVarizDetail)
      formdata.append('WwwtblcomboIdNahveVarizGrp7', this.nahvepardakht)
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('RequestTarix', this.$store.state.JalaliDate)
      formdata.append('Mablagh', this.vamDetail.MablaghVam)
      formdata.append('MablaghTavanaiePardakht', this.vamDetail.MablaghVam)
      formdata.append('TedadGhest', this.vamDetail.TedadGhest)
      formdata.append('NeedTarix', this.vamDetail.NeedData)
      formdata.append('CodeMeliZamenAsli', this.ListCodeMeli[0])
      formdata.append('CodeMeliZamenFarei', this.ListCodeMeli[1])
      formdata.append('NameFamilyZamenAsli', this.ListZamen[0].NameFamily == null ? '' : this.ListZamen[0].NameFamily)
      formdata.append('CodeMeliMoaref', this.ListCodeMeli[2])
      formdata.append('PedarZamenAsli', this.ListZamen[0].Pedar == null ? '' : this.ListZamen[0].Pedar)
      formdata.append('TelZamenAsli', this.ListZamen[0].Tel == null ? '' : this.ListZamen[0].Tel)
      formdata.append('MobileZamenAsli', this.ListZamen[0].Mobile == null ? '' : this.ListZamen[0].Mobile)
      formdata.append('AdresZamenAsli', this.ListZamen[0].Adres == null ? '' : this.ListZamen[0].Adres)
      formdata.append('MobileZamenFarei', this.ListZamen[1].Mobile == null ? '' : this.ListZamen[1].Mobile)
      formdata.append('AdresZamenFarei', this.ListZamen[1].Adres == null ? '' : this.ListZamen[1].Adres)
      formdata.append('TelZamenFarei', this.ListZamen[1].Tel == null ? '' : this.ListZamen[1].Tel)
      formdata.append('PedarZamenFarei', this.ListZamen[1].Pedar == null ? '' : this.ListZamen[1].Pedar)
      formdata.append('NameFamilyZamenFarei', this.ListZamen[1].NameFamily == null ? '' : this.ListZamen[1].NameFamily)
      formdata.append('ShoghlZamenAsli', this.ListZamen[0].Job == null ? '' : this.ListZamen[0].Job)
      formdata.append('ShoghlZamenFarei', this.ListZamen[1].Job == null ? '' : this.ListZamen[1].Job)
      formdata.append('ShoglMoaref', this.ListZamen[2].Job == null ? '' : this.ListZamen[2].Job)
      formdata.append('AdresMoaref', this.ListZamen[2].Adres == null ? '' : this.ListZamen[2].Adres)
      formdata.append('MobileMoaref', this.ListZamen[2].Mobile == null ? '' : this.ListZamen[2].Mobile)
      formdata.append('TellMoaref', this.ListZamen[2].Tel == null ? '' : this.ListZamen[2].Tel)
      formdata.append('PedarMoaref', this.ListZamen[2].Pedar == null ? '' : this.ListZamen[2].Pedar)
      formdata.append('NameFamiliMoaref', this.ListZamen[2].NameFamily == null ? '' : this.ListZamen[2].NameFamily)
      formdata.append('AzaIdMoaref', this.ListZamen[2].Id == null ? '' : this.ListZamen[2].Id)
      formdata.append('AzaIdZamenFarei', this.ListZamen[1].Id == null ? '' : this.ListZamen[2].Id)
      formdata.append('AzaIdZamen', this.ListZamen[0].Id == null ? '' : this.ListZamen[0].Id)
      formdata.append('IsTaeidVam', 0)
      formdata.append('wwwtblNoeId', this.SelectedVam.id)
      if (this.attachment) {
        formdata.append('file', this.attachment)
      }
      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'InsNewVam',
        Token: this.$session.get('TokenNetPa'),
      }

      this.$PostFormData(DataAxiosSubmit)
        .then((data) => {
          if (data.success == 'SUCCESS') {
            const fileErrorMsg = 'درخواست وام ثبت نشد. خطا در ذخیره فایل.'
            const cancelIncomplete = (id) => {
              if (!id) return
              var formCancel = new FormData()
              formCancel.append('needVamId', id)
              this.$PostFormData({
                ArryfildValue: formCancel,
                Method: 'Post',
                Action: 'InsNewVam/CancelIncompleteNeedVam',
                Token: this.$session.get('TokenNetPa'),
              }).then(() => {})
            }
            const showFileError = (needIdToCancel) => {
              if (needIdToCancel) cancelIncomplete(needIdToCancel)
              this.needVamId = 0
              this.$mySweetDefault('عملیات ناموفق', fileErrorMsg, 'error', 2500)
            }
            const finishSuccess = () => {
              this.$mySweetDefault(
                'عملیات موفق',
                'درخواست وام شما با کد رهگیری ' + data.codeRahgiri + ' در سیستم ثبت شد.',
                'success',
                2500
              )
              this.$router.push('loanFollowup')
            }

            if (data.fileSaved === false) {
              showFileError()
              return
            }

            this.needVamId = data.needVamId
            if (this.$session.get('CustCode') == 868) {
              if (
                this.FileHokm868 != null &&
                this.FileZamenanat868 != null &&
                this.FileGhardad868 != null
              ) {
                var formdataAtach = new FormData()
                formdataAtach.append('needVamId', this.needVamId)
                formdataAtach.append('FileHokm868', this.FileHokm868)
                formdataAtach.append('FileZamenanat868', this.FileZamenanat868)
                formdataAtach.append('FileGhardad868', this.FileGhardad868)
                var axios = {
                  Method: 'POST',
                  Action: 'InsNewVam/Atachment868',
                  ArryfildValue: formdataAtach,
                  Token: this.$session.get('TokenNetPa'),
                }
                this.$PostFormData(axios).then((res) => {
                  if (res && res.status == 'Ok') {
                    finishSuccess()
                  } else {
                    showFileError()
                  }
                })
              } else {
                showFileError(this.needVamId)
              }
              return
            }
            finishSuccess()
          } else {
            this.needVamId = 0
            this.$mySweetDefault(
              'عملیات ناموفق',
              data.msg ? data.msg : 'درخواست شما در سیستم ثبت نشد.',
              'warning',
              2500
            )
          }
        })
        .catch((error) => {
          this.$mySweetDefault('عملیات ناموفق', 'مشکلی بوجود آمده است. دوباره تلاش کنید', 'error', 2500)
          this.needVamId = 0
          console.warn(error)
        })
    },
    CheckupSaghfVam(e) {
      if (e.target.value.replace(/,/g, '') > this.SelectedVam.mabTaeenSaghfVam) {
        this.vamDetail.MablaghVam = this.$Comma3ragham(this.SelectedVam.mabTaeenSaghfVam)
        this.calculateMablaghghest()
        this.$mySweetDefault('خطا در مبلغ تسهیلات', ' سقف مبلغ تسهیلات ' + this.$Comma3ragham(this.SelectedVam.mabTaeenSaghfVam) + ' می باشد و نمی توانید بیشتر از این مبلغ درخواست تسهیلات کنید ', 'error', 3000)
      }
    },
    OpenUploader(Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      if (Type == 1) {
        document.getElementById('FileHokm').click()
      }
      if (Type == 2) {
        document.getElementById('FileZemanat').click()
      }
      if (Type == 3) {
        document.getElementById('FileGhrardad').click()
      }
    },
    UploadFile(e, Type, FileUploaderId) {
      const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      if (e.srcElement.files[0].size / 1000000 > 3) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 3 مگابایت باشد', 'error', 2000)
        document.getElementById(FileUploaderId).value = null
      } else {
        if (Type == 1) {
          this.FileHokm868 = e.srcElement.files[0]
        }
        if (Type == 2) {
          this.FileZamenanat868 = e.srcElement.files[0]
        }
        if (Type == 3) {
          this.FileGhardad868 = e.srcElement.files[0]
        }
      }
    },
  },
  updated() {
    this.vamDetail.Mablaghghest = Math.floor(this.vamDetail.Mablaghghest)
    this.$PutCommatoInput()
    // this.vamDetail.Mablaghghest ==this.$Comma3ragham(this.vamDetail.Mablaghghest);
  },
}
</script>
<style scoped>
.request-vam-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.request-vam-step-panel {
  flex: 1 1 100%;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.request-vam-step {
  padding: 0.75rem 0;
}

.request-vam-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem 0.75rem;
  width: 100%;
  margin: 0;
  padding: 0;
}

.request-vam-form-grid > [class*="col-"] {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  flex: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (min-width: 768px) {
  .request-vam-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .request-vam-form-grid > .col-md-6 {
    flex: none;
    max-width: 100%;
    width: 100%;
  }
}

.request-vam-date-field ::v-deep .vpd-main {
  display: block;
  width: 100%;
}

.request-vam-date-field ::v-deep .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  overflow: hidden;
}

.request-vam-date-field ::v-deep .vpd-input-group input,
.request-vam-date-field ::v-deep .vpd-input-group input.form-control {
  flex: 1 1 auto;
  min-width: 0;
  height: calc(1.5em + 0.75rem + 2px);
  min-height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  padding: 0.375rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent;
  font-size: 1rem;
  line-height: 1.5;
}

.request-vam-date-field ::v-deep .vpd-input-group .vpd-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  margin: 0;
  padding: 0;
  border: none;
  border-right: 1px solid #ced4da;
  border-radius: 0;
  background: #f8f9fa;
}

.request-vam-zamen-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  width: 100%;
}

@media (min-width: 768px) {
  .request-vam-zamen-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .request-vam-zamen-slot {
    min-width: 0;
    width: 100%;
  }

  .request-vam-zamen-slot--solo {
    grid-column: 1 / -1;
    justify-self: center;
    width: 70%;
    max-width: 70%;
  }
}

.request-vam-zamen-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  overflow: hidden;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  direction: rtl;
}

.request-vam-zamen-code {
  flex: 1 1 auto;
  align-self: stretch;
  min-width: 0;
  height: auto !important;
  min-height: 100%;
  padding: 0.375rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  text-align: left;
  direction: ltr;
}

.request-vam-zamen-code::placeholder {
  text-align: right;
  direction: rtl;
}

.request-vam-zamen-code:focus {
  box-shadow: none !important;
}

.request-vam-zamen-check-btn {
  flex: 0 0 auto;
  align-self: stretch;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 4.75rem;
  height: auto;
  min-height: 100%;
  padding: 0 0.85rem;
  border: none;
  border-right: 1px solid #ced4da;
  border-radius: 0;
  background: #28a745;
  color: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  cursor: pointer;
  transition: background 0.15s ease;
}

.request-vam-zamen-check-btn:hover {
  background: #218838;
}

.request-vam-zamen-result {
  width: 100%;
  max-width: 100%;
  margin-top: 0.5rem;
  padding: 0.55rem 0.75rem;
  border: 1px solid rgba(40, 167, 69, 0.35);
  border-radius: 0.25rem;
  background: rgba(40, 167, 69, 0.08);
  text-align: right;
}

.request-vam-zamen-result__name {
  margin-right: 0.35rem;
}

.request-vam-upload-section {
  width: 100%;
}

.request-vam-upload-download {
  margin-bottom: 0.75rem;
}

.request-vam-upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1.25rem 1rem;
  border: 1px dashed #b8c5d6;
  border-radius: 12px;
  background: #f8faff;
  text-align: center;
}

.request-vam-upload-card--item {
  min-height: 11rem;
}

.request-vam-upload-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
}

@media (min-width: 768px) {
  .request-vam-upload-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.request-vam-upload-card__icon {
  font-size: 2rem;
  color: #2a3f54;
  line-height: 1;
}

.request-vam-upload-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
}

.request-vam-upload-card__hint {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
  line-height: 1.5;
}

.request-vam-upload-card__meta {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  background: #fff;
  font-size: 13px;
  text-align: right;
}

.request-vam-upload-card__file-name {
  margin: 0;
  font-size: 12px;
  color: #28a745;
  word-break: break-word;
}

.request-vam-upload-card__btn {
  min-height: 34px;
  padding: 0.35rem 1rem;
  border: none;
  border-radius: 8px;
  background: #2a3f54;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.request-vam-upload-card__btn:hover {
  background: #1f2f3f;
}

.request-vam-review-header {
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eef1f5;
}

.request-vam-review-header__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #2a3f54;
}

.request-vam-review-section {
  margin-bottom: 1rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  background: #fff;
}

.request-vam-review-section--loan {
  border-right: 3px solid #007bff;
}

.request-vam-review-section--guarantors {
  border-right: 3px solid #28a745;
}

.request-vam-review-section--files {
  border-right: 3px solid #dc3545;
  margin-bottom: 0;
}

.request-vam-review-section__title {
  margin: 0 0 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #eef1f5;
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
  text-align: right;
}

.request-vam-review-fields {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.request-vam-review-guarantor-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.request-vam-review-guarantor-empty {
  padding: 0.75rem 0.85rem;
  border-radius: 10px;
  background: #f8faff;
  color: #6c757d;
  font-size: 14px;
  text-align: right;
}

.request-vam-review-guarantor-card {
  overflow: hidden;
  border-radius: 10px;
  background: #f8faff;
}

.request-vam-review-guarantor-card__header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.85rem;
  background: rgba(40, 167, 69, 0.1);
  border-bottom: 1px solid rgba(40, 167, 69, 0.15);
  text-align: right;
}

.request-vam-review-guarantor-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 1.75rem;
  height: 1.75rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #28a745;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.request-vam-review-guarantor-card__title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
  word-break: break-word;
}

.request-vam-review-guarantor-card__grid {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0.35rem 0.85rem 0.65rem;
}

.request-vam-review-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  width: 100%;
  padding: 0.55rem 0;
  border-bottom: 1px solid rgba(42, 63, 84, 0.08);
  direction: rtl;
  text-align: right;
}

.request-vam-review-field:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.request-vam-review-field--full {
  align-items: flex-start;
}

.request-vam-review-field__label {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  line-height: 1.5;
  white-space: nowrap;
}

.request-vam-review-field__label::after {
  content: ":\00a0";
}

.request-vam-review-field__value {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 62%;
  font-size: 14px;
  font-weight: 500;
  color: #2a3f54;
  line-height: 1.5;
  text-align: left;
  word-break: break-word;
}

.request-vam-review-field__value--ltr {
  direction: ltr;
  unicode-bidi: isolate;
  text-align: left;
}

.request-vam-review-files {
  text-align: right;
}

.request-vam-step-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eef1f5;
  direction: rtl;
}

.request-vam-step-nav--next-only {
  justify-content: flex-end;
}

.request-vam-step-nav__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  padding: 0.3rem 0.75rem;
  border: 1px solid transparent;
  border-radius: 8px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
    opacity 0.15s ease;
}

.request-vam-step-nav__btn i {
  font-size: 12px;
}

.request-vam-step-nav__btn:focus {
  outline: none;
}

.request-vam-step-nav__btn:focus-visible {
  outline: 2px solid rgba(42, 63, 84, 0.35);
  outline-offset: 2px;
}

.request-vam-step-nav__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.request-vam-step-nav__btn--prev {
  color: #856404;
  background: #fff3cd;
  border-color: #ffecb5;
}

.request-vam-step-nav__btn--prev:hover:not(:disabled) {
  color: #6d4c00;
  background: #ffe69c;
  border-color: #ffd966;
}

.request-vam-step-nav__btn--next {
  color: #fff;
  background: #28a745;
  border-color: #28a745;
}

.request-vam-step-nav__btn--next:hover:not(:disabled) {
  color: #fff;
  background: #218838;
  border-color: #1e7e34;
}

.request-vam-step-nav__btn--submit {
  color: #fff;
  background: #28a745;
  border-color: #28a745;
  padding-inline: 0.9rem;
}

.request-vam-step-nav__btn--submit:hover:not(:disabled) {
  background: #218838;
  border-color: #218838;
}

@media (max-width: 767px) {
  .request-vam-step-nav {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .request-vam-step-nav--next-only {
    justify-content: flex-end;
  }

  .request-vam-step-nav__btn {
    width: auto;
    flex: 0 1 auto;
  }
}

.request-vam-type-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
  width: 100%;
  max-width: 100%;
}

.request-vam-type-card {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0.85rem 1rem;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(42, 63, 84, 0.06);
}

.request-vam-type-card--selected {
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.12);
  box-shadow: 0 2px 10px rgba(40, 167, 69, 0.18);
}

.request-vam-type-card__row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
  direction: ltr;
}

.request-vam-type-card__aside {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  min-height: 2.25rem;
}

.request-vam-type-card__select-btn {
  white-space: nowrap;
  min-width: 5.5rem;
  border-radius: 8px !important;
}

.request-vam-type-card__check {
  flex-shrink: 0;
  font-size: 1.35rem;
  color: #28a745;
  line-height: 1.4;
}

.request-vam-type-card__info {
  flex: 1;
  min-width: 0;
  width: 100%;
  text-align: right;
}

.request-vam-type-card--selected .request-vam-type-card__label {
  color: #1e7e34;
}

.request-vam-type-card--selected .request-vam-type-card__title {
  color: #155724;
}

.request-vam-type-card--selected .request-vam-type-card__desc {
  color: #1e7e34;
}

.request-vam-type-card__name {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  text-align: right;
  gap: 0.25rem;
}

.request-vam-type-card__label {
  display: block;
  width: 100%;
  font-size: 13px;
  color: #6c757d;
}

.request-vam-type-card__title {
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: #2a3f54;
  line-height: 1.5;
  word-break: break-word;
}

.request-vam-type-card__desc {
  width: 100%;
  margin: 0.35rem 0 0;
  font-size: 13px;
  color: #6c757d;
  line-height: 1.55;
  text-align: right;
  word-break: break-word;
}

.blueback {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.yellowback {
  width: 100%;
  min-height: 80px;
  background: rgb(208, 224, 118);
  border: 2px dotted #929c04;
  border-radius: 15px;
}

.Uploader {
  width: 100%;
  height: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}

.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
</style>
<style>
.request-vam-content,
.request-vam-step-panel,
.request-vam-type-list,
.request-vam-type-card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.request-vam-steps {
  margin-bottom: 0.25rem;
}

.request-vam-steps .nav-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  cursor: pointer;
}

.request-vam-steps .nav-link:disabled,
.request-vam-steps .nav-link.request-vam-steps__tab--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none !important;
  transform: none !important;
}

.request-vam-steps .nav-link.request-vam-steps__tab--completed:not(.active):not(:disabled) {
  color: #1e7e34;
  background: rgba(40, 167, 69, 0.1);
}

.request-vam-steps .nav-link.request-vam-steps__tab--completed:not(.active):not(:disabled):hover {
  background: rgba(40, 167, 69, 0.16);
  color: #19692c;
}

.request-vam-steps .nav-link.active .request-vam-steps__check {
  color: #28a745;
}

.request-vam-steps .nav-link .request-vam-steps__check {
  flex-shrink: 0;
  font-size: 14px;
  color: #28a745;
}

@media (max-width: 767px) {
  .request-vam-steps .nav-item {
    flex: 1 1 calc(50% - 2px);
    min-width: 0;
  }

  .request-vam-steps .nav-link {
    min-height: 44px;
    padding: 0.5rem 0.45rem;
    font-size: 12px !important;
    line-height: 1.35;
  }

  .request-vam-steps .nav-link .request-vam-steps__check {
    font-size: 12px;
  }
}
</style>
